// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	ConsultarDigitaisIIRGDState,
	ConsultarDigitaisIIRGDRequest,
	Types,
} from './types';

export function consultarDigitaisIIRGDRequest(
	token: string,
	payload: ConsultarDigitaisIIRGDRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DIGITAIS_IIRGD_REQUEST,
		token,
		payload,
	};
}
export function consultarDigitaisIIRGDSuccess(
	payload: ConsultarDigitaisIIRGDState,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DIGITAIS_IIRGD_SUCCESS,
		payload,
	};
}
export function consultarDigitaisIIRGDFailure(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DIGITAIS_IIRGD_FAILURE,
		payload,
	};
}
export function consultarDigitaisIIRGDClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DIGITAIS_IIRGD_CLEAR,
		payload: null,
	};
}
